import CmsBlock from "./CmsBlock";

export default CmsBlock;
